import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WHY_ITEMS, PHONE, PHONE_HREF } from "@/lib/site-data";

export default function WhyPhillips() {
  return (
    <section id="why" data-testid="why-phillips-section" className="bg-black py-28 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-[1fr_1.3fr] gap-16">
        <div className="lg:sticky lg:top-28 self-start">
          <Reveal>
            <Overline>03 — Why Phillips</Overline>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
              Why Choose Phillips?
            </h2>
            <p className="mt-5 text-gray-400 max-w-md leading-relaxed">
              Anyone can promise quality. We'd rather show it — in the way we communicate, the way we
              build, and the way we stand behind the finished work.
            </p>
            <div className="mt-8 relative rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1787672357797-f5fa35bb0d18?auto=format&fit=crop&q=80&w=900"
                alt="Phillips crew member on site"
                loading="lazy"
                className="h-64 w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            </div>
            <a
              href={PHONE_HREF}
              data-testid="why-call-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-[#0066FF] px-7 py-4 font-display text-sm font-semibold tracking-widest text-white transition-[background-color,box-shadow] duration-300 hover:bg-[#00E5FF] hover:text-black hover:shadow-[0_0_30px_rgba(0,229,255,0.5)]"
            >
              TALK TO OUR TEAM — {PHONE} <ArrowRight size={16} />
            </a>
          </Reveal>
        </div>

        <div>
          {WHY_ITEMS.map((item, i) => (
            <Reveal key={item.num} delay={0.05 * i}>
              <div data-testid={`why-item-${item.num}`} className="border-t border-white/10 py-10 flex gap-6 md:gap-10 items-start group">
                <span
                  className="font-display text-6xl md:text-8xl font-bold leading-none shrink-0 text-transparent"
                  style={{ WebkitTextStroke: "1.5px rgba(255,255,255,0.16)" }}
                >
                  {item.num}
                </span>
                <div>
                  <h3 className="font-display text-2xl md:text-[1.75rem] font-semibold text-white group-hover:text-cyan-400 transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-gray-400 leading-relaxed max-w-lg">{item.desc}</p>
                  <div className="mt-5 h-[3px] w-12 bg-gradient-to-r from-[#00E5FF] to-[#0066FF] transition-[width] duration-500 group-hover:w-24" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
